export enum Culture {
  MONOLAYER = 'MONOLAYER',

  MULTICULTURE = 'MULTICULTURE',

  SPHEROID = 'SPHEROID',
}
